import _find from 'lodash/find';

import specializationTypes from 'utils/constants/specializationTypes';

export default (id, specializations) => {
  const foundSpecialization = _find(specializations, (specialization) => specialization.id === id);

  return foundSpecialization && foundSpecialization.name === specializationTypes.STUDENT;
};
